/* eslint-disable global-require */
import React, { useEffect } from 'react';
import { ApolloProvider } from '@apollo/react-hooks';
import { ToastProvider, DefaultToastContainer } from 'react-toast-notifications';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { ModalProvider } from 'styled-react-modal';

import { apolloClient } from '../../lib';
import { routes } from '../../constants';
import { Register, Login, ChangePassword } from '..';
import Admin from '../../layouts/Admin';

import '../../assets/css/fontawesome.min.css';
import '../../assets/css/bootstrap.min.css';
import '../../assets/fonts/flaticon.css';
import '../../assets/css/animate.css';
import '../../assets/css/owl.carousel.min.css';
import '../../assets/css/magnific-popup.css';
import '../../assets/css/material-dashboard-react.scss';
import '../../assets/css/style.scss';
import '../../assets/css/responsive.scss';

import { useScrollToTop } from '../../hooks';

const MyCustomToastContainer = (props) => <DefaultToastContainer {...props} style={{ zIndex: 9999 }} />;

function AppRoutes() {
  const pn = window.location.pathname;
  useEffect(() => {
    if (pn.startsWith(routes.dashboard.pathname)) {
      document.getElementById('_browncon-body').className = '_browncon-body-dashboard';
    } else {
      document.getElementById('_browncon-body').className = '_browncon-body-base';
    }
  }, [pn]);

  useScrollToTop();
  return (
    <Switch>
      <Route path={routes.dashboard.pathname}>
        <Admin />
      </Route>
      {/* <Route path={routes.about.pathname}>
              <div>coming soon</div>
            </Route> */}
      <Route path={routes.register.pathname}>
        <Register />
      </Route>
      <Route path={routes.join.pathname}>
        <Register />
      </Route>
      <Route path={routes.login.pathname}>
        <Login />
      </Route>
      <Route path={routes.changePassword.pathname}>
        <ChangePassword />
      </Route>
      <Route path={routes.home.pathname}>
        <Login />
      </Route>
    </Switch>
  );
}

function App() {
  return (
    <ToastProvider components={{ ToastContainer: MyCustomToastContainer }}>
      <ModalProvider>
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </ApolloProvider>
      </ModalProvider>
    </ToastProvider>
  );
}

export default App;
